import logoPic from '../assets/logo.jpg';
const NavBar = () => {
    return ( 
        <div className="navbar">
            <nav>
                <div class="logo">
                    <img src={logoPic} alt="Logo" class="logo-img" />
                    <h1 class="logo-text">HIMANSHU DUTT</h1>
                </div>
                <div class="mobile-nav-items">
                    <a href="https://www.linkedin.com/in/himanshu-dutt-702b72200/"  target="_blank" rel="noreferrer" class="contact-button">Contact</a>
                </div>
            </nav>
        </div>
     );
}
 
export default NavBar;